const MsMeritCriteriaPage = () => {
  return (
    <div className="container mx-auto py-8 px-4">
      <h1 className="text-3xl font-bold mb-6">MS Programs Merit Criteria</h1>

      <div className="bg-white shadow-md rounded-lg p-6 mb-8">
        <h2 className="text-2xl font-semibold mb-4">
          Merit Calculation Formula
        </h2>

        <p className="mb-6">
          The merit for MS programs is calculated using the following weightage:
        </p>

        <div className="overflow-x-auto">
          <table className="min-w-full bg-white border border-gray-300">
            <thead>
              <tr className="bg-gray-100">
                <th className="py-3 px-4 border-b text-left">Component</th>
                <th className="py-3 px-4 border-b text-left">Weightage</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td className="py-3 px-4 border-b">
                  Previous Academic Record (16 years education)
                </td>
                <td className="py-3 px-4 border-b">50%</td>
              </tr>
              <tr className="bg-gray-50">
                <td className="py-3 px-4 border-b">Admission Test Score</td>
                <td className="py-3 px-4 border-b">30%</td>
              </tr>
              <tr>
                <td className="py-3 px-4 border-b">Interview Performance</td>
                <td className="py-3 px-4 border-b">15%</td>
              </tr>
              <tr className="bg-gray-50">
                <td className="py-3 px-4 border-b">
                  Research/Professional Experience
                </td>
                <td className="py-3 px-4 border-b">5%</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      <div className="bg-white shadow-md rounded-lg p-6 mb-8">
        <h2 className="text-2xl font-semibold mb-4">
          Minimum Merit Requirements
        </h2>

        <div className="overflow-x-auto">
          <table className="min-w-full bg-white border border-gray-300">
            <thead>
              <tr className="bg-gray-100">
                <th className="py-3 px-4 border-b text-left">Program</th>
                <th className="py-3 px-4 border-b text-left">
                  Minimum Merit Score
                </th>
                <th className="py-3 px-4 border-b text-left">
                  Minimum Test Score
                </th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td className="py-3 px-4 border-b">MS Computer Science</td>
                <td className="py-3 px-4 border-b">60%</td>
                <td className="py-3 px-4 border-b">50%</td>
              </tr>
              <tr className="bg-gray-50">
                <td className="py-3 px-4 border-b">
                  MS Artificial Intelligence
                </td>
                <td className="py-3 px-4 border-b">65%</td>
                <td className="py-3 px-4 border-b">55%</td>
              </tr>
            </tbody>
          </table>
        </div>

        <p className="mt-4 text-sm text-gray-600">
          * Candidates must meet both the minimum merit score and the minimum
          test score to be considered for admission.
        </p>
      </div>

      <div className="bg-white shadow-md rounded-lg p-6 mb-8">
        <h2 className="text-2xl font-semibold mb-4">
          Previous Academic Record Conversion
        </h2>

        <p className="mb-4">
          The previous academic record is converted to a percentage using the
          following formula:
        </p>

        <div className="bg-gray-100 p-4 rounded-lg mb-4">
          <p className="font-mono">For CGPA (out of 4.0): (CGPA ÷ 4.0) × 100</p>
          <p className="font-mono mt-2">For percentage: Used as is</p>
        </div>

        <p className="mb-4">
          For candidates with degrees from foreign universities, the equivalence
          established by HEC will be used.
        </p>
      </div>

      <div className="bg-white shadow-md rounded-lg p-6 mb-8">
        <h2 className="text-2xl font-semibold mb-4">
          Admission Test Equivalence
        </h2>

        <p className="mb-4">
          Candidates can submit scores from the following standardized tests in
          lieu of the NIIT MS Admission Test:
        </p>

        <div className="overflow-x-auto">
          <table className="min-w-full bg-white border border-gray-300">
            <thead>
              <tr className="bg-gray-100">
                <th className="py-3 px-4 border-b text-left">Test</th>
                <th className="py-3 px-4 border-b text-left">
                  Minimum Score Required
                </th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td className="py-3 px-4 border-b">
                  GRE General (Quantitative)
                </td>
                <td className="py-3 px-4 border-b">155 (or 60th percentile)</td>
              </tr>
              <tr className="bg-gray-50">
                <td className="py-3 px-4 border-b">
                  GRE Subject (Computer Science)
                </td>
                <td className="py-3 px-4 border-b">650 (or 60th percentile)</td>
              </tr>
              <tr>
                <td className="py-3 px-4 border-b">NTS GAT General</td>
                <td className="py-3 px-4 border-b">60 (out of 100)</td>
              </tr>
            </tbody>
          </table>
        </div>

        <p className="mt-4 text-sm text-gray-600">
          * Test scores must not be older than 2 years at the time of
          application.
        </p>
      </div>

      <div className="bg-white shadow-md rounded-lg p-6 mb-8">
        <h2 className="text-2xl font-semibold mb-4">
          Interview Evaluation Criteria
        </h2>

        <p className="mb-4">
          The interview evaluates candidates on the following aspects:
        </p>

        <ul className="list-disc pl-6 space-y-2">
          <li>Subject knowledge and technical competence</li>
          <li>Research aptitude and analytical thinking</li>
          <li>Communication skills</li>
          <li>Motivation and career goals</li>
          <li>Potential for academic success</li>
        </ul>
      </div>

      <div className="mt-8 bg-blue-50 p-4 rounded-lg border border-blue-200">
        <h3 className="text-lg font-semibold text-blue-800 mb-2">
          Important Notes:
        </h3>
        <ul className="list-disc pl-5 text-blue-800">
          <li className="mb-1">
            Meeting the minimum merit criteria does not guarantee admission, as
            seats are limited and offered on a competitive basis.
          </li>
          <li className="mb-1">
            The admission committee's decision is final in all matters related
            to admissions.
          </li>
          <li className="mb-1">
            For any queries regarding merit calculation, please contact the
            admissions office.
          </li>
        </ul>
      </div>
    </div>
  );
};

export default MsMeritCriteriaPage;
